import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import JSZip from "jszip";
import 'common/css/master.css';
import Header from 'common/js/header/header.js';
import HeaderSession from 'common/components/headerSession';
import { getLstSession, getLstTTSummary, deleteRow, publish, publishAll, getAllClsSecTTView } from './classWiseServices';
import ClassWiseSummaryTbl from './classWiseSummaryTbl';

const ClassWiseCtrl = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [selSessionId, setSelSessionId] = useState(0)
    const [lstSession, setLstSession] = useState([]);
    const [lstTTSummary, setLstTTSummary] = useState([]);
    const [key, setKey] = useState(0);

    useEffect(() => {
        setSessions();

    }, []);


    function setSessions() {
        setLoader("block");
        setOpacity(0.5);
        getLstSession(handleLstSessionResponse);
    }
    function handleLstSessionResponse(data) {
        // console.log(data)
        var obj = data;
        if (obj.status === 'Success') {
            // console.log(obj.lstSession)
            setLstSession(obj.lstSession);
        } else if (obj.status === 'Failure') {
            if (obj.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        } else {
            console.error("Service failed " + obj.message);
        }
        setLoader("none");
        setOpacity(1);
    }


    function setTTSummary(sessionId) {
        setLoader("block");
        setOpacity(0.5);
        getLstTTSummary(sessionId, handleLstTTSummaryResponse);
    }

    function handleLstTTSummaryResponse(data) {
        var obj = data;
        if (obj.status === 'Success') {
            setLstTTSummary(obj.lstTTSummary);
        } else if (obj.status === 'Failure') {
            if (obj.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        } else {
            toast.error("Service failed " + obj.message);
        }
        setLoader("none");
        setOpacity(1);
    }

    const getWingId = (wingId) => {
        // console.log("wingId" + wingId);
    }
    const clickSessionTab = (e, sessionId) => {
        for (let sibling of e.currentTarget.parentNode.children) {
            if (sibling !== e.target) sibling.classList.remove('active');
        }
        e.currentTarget.classList.add('active');
        setSelSessionId(sessionId);
        setTTSummary(sessionId);
    }

    function remove(clsId, sectionId) {
        deleteRow(clsId, sectionId, selSessionId)
    }

    function send(clsId, sectionId) {
        publish(clsId, sectionId, selSessionId)
    }

    const removeResponse = (data) => {
        // console.log("saveContentResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            updateKey();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }



    function edit(clsId, sectionId, sessionId, data) {
        // console.log("Edit method called onclick edit icon, parameters passed to edit clsId", clsId, ", sectionId", sectionId, "sessionId", sessionId, ", data", data);
        var obj = data;
        if (obj.subAllocation) {
            // localStorage.setItem("clsId", clsId);
            // localStorage.setItem("sectionId", sectionId);
            // localStorage.setItem("sessionId", sessionId);
            // window.open('/tttch');
            const teacherTTURL = "/tttch?clsId=" + clsId + "&sectionId=" + sectionId + "&sessionId=" + sessionId;
            window.open(teacherTTURL);

        } else {
            // localStorage.setItem("clsId", clsId);
            // localStorage.setItem("sectionId", sectionId);
            // localStorage.setItem("sessionId", sessionId);
            // window.open('/ttsub')
            const subjectTTURL = "/ttsub?clsId=" + clsId + "&sectionId=" + sectionId + "&sessionId=" + sessionId;
            window.open(subjectTTURL);
        }
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };


    const updateKey = () => {
        setKey(prevKey => prevKey + 1);
    }

    const publishAllPdf = () => {
        // console.log("publishAllPdf called");
        if (!lstTTSummary || lstTTSummary.length === 0) {
            toast.warning("No class summary available to publish.");
            return;
        }
        var retVal = window.confirm("Do you want to publish for all classes ?");
        if (retVal === true) {
            setLoader("block");
            setOpacity(0.5);
            // Create an array of promises for all publishAll calls
            const publishPromises = lstTTSummary.map(item =>
                new Promise((resolve) => {
                    publishAll(item.clsId, item.sectionId, selSessionId, (data) => {
                        // Optionally handle response here
                        resolve(data);
                    });
                })
            );
            // Wait for all to finish, then refresh
            Promise.all(publishPromises).then(() => {
                setLoader("none");
                setOpacity(1);
                setTTSummary(selSessionId);
                toast.success("All class summaries published successfully.");
            });
        }
    }

    const downloadAllPdf = async () => {
        // console.log("downloadAllPdf called");
        if (!lstTTSummary || lstTTSummary.length === 0) {
            toast.warning("No class summary available to download.");
            return;
        }
        setLoader("block");
        setOpacity(0.5);

        const zip = new JSZip();
        const pdfPromises = lstTTSummary.map(item =>
            new Promise((resolve) => {
                getAllClsSecTTView(item.clsId, item.sectionId, selSessionId, (data) => {
                    // console.log("getAllClsSecTTView response", data, "type of data.data:", typeof data.data, "is ArrayBuffer:", data.data instanceof ArrayBuffer);
                    if (data && data.data && data.data instanceof ArrayBuffer && data.data.byteLength > 0) {
                        const fileName = `${item.cls || "class"}-${item.section || ""}.pdf`;
                        zip.file(fileName, new Uint8Array(data.data));
                    } else {
                        // console.log("Invalid or empty PDF data for", item.cls, item.section, data.data);
                    }
                    resolve();
                });
            })
        );

        await Promise.all(pdfPromises);

        zip.generateAsync({ type: "blob" }).then((content) => {
            const url = URL.createObjectURL(content);
            const a = document.createElement('a');
            a.href = url;
            a.download = "class_summaries.zip";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            setLoader("none");
            setOpacity(1);
            toast.success("All class summaries downloaded successfully.");
        });
    }


return (
    <div style={{ height: '100%' }}>
        <Header wingFromChild={getWingId} />
        <ToastContainer autoClose={3000} hideProgressBar />
        <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
            <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
        </div>
        <div className="mainContainer" style={{ marginTop: 15, opacity: opacity }}>
            <div className={lstSession.length > 4 ? "col-sm-11 col-centered padding-remove" : "col-sm-6 col-centered padding-remove"}>
                {/* style={{width:"145px",marginLeft:"315px"}} */}
                {lstSession.length !== 0 &&
                    <HeaderSession
                        lstSession={lstSession}
                        clickSessionTab={clickSessionTab}
                    />}
                {/* <h1>HeaderSession to be placed here</h1> */}
            </div>
            <div className="col-sm-7 col-centered padding-remove">
                {/* <ClassWiseSummaryTbl lstTTSummary={lstTTSummary} /> */}
                <div className="col-sm-12 padding-remove">
                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12, gap: "10px" }}>
                        <button
                            className="btn btn-success"
                            onClick={() => publishAllPdf()}
                            disabled={!lstTTSummary || lstTTSummary.length === 0}
                        >
                            Publish Class Summary
                        </button>
                        <button
                            className="btn btn-success"
                            onClick={() => downloadAllPdf()}
                            disabled={!lstTTSummary || lstTTSummary.length === 0}
                        >
                            Download Class Summary
                        </button>
                    </div>
                </div>
                <ClassWiseSummaryTbl
                    lstTTSummary={lstTTSummary}
                    remove={remove}
                    edit={edit}
                    send={send}
                    selSessionId={selSessionId} />
            </div>
        </div>
    </div >
)
}

export default ClassWiseCtrl